import React from "react";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  Button
} from "reactstrap";

import EditModal from "../modal/EditModal";

class FoodUserThumbnail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      id: ""
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle(target_index) {
    this.setState({
      modal: !this.state.modal,
      id: target_index
    });
  }
  render() {
    return (
      <div className="width-full">
        <h1 className="center sub-title">List of Your Food</h1>
        <Row className="width-full homeProduct center">
          {this.props.userFoods.map((dataId, index) => (
            <Col
              xs={11}
              sm={5}
              md={4}
              lg={3}
              className="card-full border-red"
              key={index}
            >
              <Card>
                <CardImg
                  height="50%"
                  src={dataId.photos[0][0]}
                  alt="Food Image"
                />
                <CardBody>
                  <CardTitle>{dataId.name}</CardTitle>
                  <div className="center">
                    <Button
                      className="width-full margin-all-5"
                      onClick={() => {
                        this.toggle(index);
                      }}
                    >
                      Edit
                    </Button>
                    <EditModal
                      toggle={this.toggle}
                      id={this.state.id}
                      modal={this.state.modal}
                      userFoods={this.props.userFoods}
                    />
                    <Button
                      className="width-full margin-all-5"
                      onClick={() => {
                        this.props.deleteFood(index);
                      }}
                    >
                      Delete
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}

export default withRouter(FoodUserThumbnail);



// WEBPACK FOOTER //
// ./src/medium/FoodUserThumbnail.jsx